import React, { useEffect, useState } from 'react';
import { Form, Button, Col, Row, Container, InputGroup } from "react-bootstrap";
import { isEmpty, isBoolean } from "lodash";
import { capitalizeFirstLetter } from 'components/JobApplication/Shared/Helpers';
import { renderCheckbox, renderLabelYesNo } from 'components/HSInduction/Shared/Helpers';
import CustomSweetAlert from 'components/Shared/CustomSweetAlert';

const StepThree = ({ handleNext, handleBack, storedData }) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0)
        if (storedData) {
            setFormData(storedData?.generalHealth || {});
        }
    }, []);

    const validateForm = (formData) => {
        const errors = {
            goodHealthCurrently: !isBoolean(formData?.goodHealthCurrently) && 'This filed is required',
            absentFromWorkIn3Years: !isBoolean(formData?.absentFromWorkIn3Years) && 'This filed is required',
            numberOfEpisodes: isEmpty(formData.numberOfEpisodes?.toString()) && 'This filed is required',
            totalSickDays: isEmpty(formData.totalSickDays?.toString()) && 'This filed is required',
            smoke: !isBoolean(formData?.smoke) && 'This filed is required',
            smokesPerDay: isEmpty(formData.smokesPerDay?.toString()) && 'This filed is required',
            drinkAlcohol: !isBoolean(formData?.drinkAlcohol) && 'This filed is required',
            alcoholUnitPerWeek: isEmpty(formData?.alcoholUnitPerWeek?.toString()) && 'This filed is required',
            deniedOrLeftJobForHealth: !isBoolean(formData?.deniedOrLeftJobForHealth) && 'This filed is required',
            deniedDrivingLicenseForHealth: !isBoolean(formData?.deniedDrivingLicenseForHealth) && 'This filed is required',
            consideredDisable: !isBoolean(formData?.consideredDisable) && 'This filed is required',
            treatedForAddiction: !isBoolean(formData?.treatedForAddiction) && 'This filed is required',
            anyMedicalConditionsAffectingEmployment: !isBoolean(formData?.anyMedicalConditionsAffectingEmployment) && 'This filed is required',
        };
        return errors;
    }

    const handleSubmit = async () => {
        try {
            const errors = validateForm(formData);
            if (!Object.values(errors).some(Boolean)) {
                setErrors([]);
                handleSaveData(formData);
            } else {
                setErrors(errors);
                window.scrollTo(0, 0);
            }
        } catch (e) {
            console.log(e);
        }
    }

    const handleSaveData = async (postData) => {
        setAlert(CustomSweetAlert({ type: "loading" }));
        try {
            const url = `/HSInduction/SubmitGeneralHealth?inductionId=${storedData?.inductionId}&employeeId=${storedData?.employeeId}&pin=${storedData?.pin}`;
            const method = `post`;
            const response = await fetch(apiURL + url, {
                method,
                headers: [
                    ["Content-Type", "application/json"],
                    ["Content-Type", "text/plain"]
                ],
                body: JSON.stringify(postData),
            });
            if (response.status === 200) {
                handleNext(postData);
            } else {
                setAlert(CustomSweetAlert({
                    type: "error", title: "Error", message: `Error: Save step 3 failed`,
                    onConfirm: () => {
                        hideAlert();
                    }, showCancel: false
                }));
            }
        } catch (e) {
            console.log(e);
            showErrorAlert(`Something went wrong`);
        }

    }

    const handleChangeData = (value, name) => {
        setFormData({ ...formData, [name]: value });
    }

    const handleCapitalWord = (event, keyName) => {
        handleChangeData(capitalizeFirstLetter(event.target.value), keyName);
    };

    const renderInput = (name) => {
        return <>
            <Form.Control type="text"
                value={formData[name]}
                onChange={(e) => handleChangeData(e.target.value, name)}
                className={errors[name] ? "form-control is-invalid custom-input mb-2" : "form-control custom-input mb-2"}
            />
        </>
    }

    const renderQuestion = (type, name, label) => {
        const value = formData[name]?.toString() || null;
        return <>
            <Col md={8} className='text-start'>
                {label}
            </Col>
            <Col md={4} className='align-self-center'>
                {type == 'boolean' ? renderCheckbox(name, handleChangeData, value) : renderInput(name)}
            </Col>
        </>
    }

    const hideAlert = () => setAlert(null);

    return (
        <>
            <Row>
                {alert}
                <Col sm={12} md={12}>
                    <h2>3. General Health</h2>
                    <span style={{ marginTop: '-15px' }}>Please tick appropriate boxes. If you answer yes, please provide details of the treatment including medication(s) in the General Health Comments box below.</span>
                </Col>
                <Col md={12} xs="12" className="mx-auto">
                    <Container>
                        <Row>
                            {renderQuestion('boolean', 'goodHealthCurrently', <h5 className="mb-1">a/ Are you currently in good health?<span className="star">*</span></h5>)}
                            {renderQuestion('boolean', 'absentFromWorkIn3Years', <h5 className="mb-1">b/ Have you been absent from work in the last 3 years due to sickness?<span className="star">*</span></h5>)}
                            {renderQuestion('input', 'numberOfEpisodes', <h5 style={{ paddingLeft: "4rem" }}>i/ How many episodes of sick have you taken?<span className="star">*</span></h5>)}
                            {renderQuestion('input', 'totalSickDays', <h5 style={{ paddingLeft: "4rem" }}>ii/ How many day's sick have you taken in total?<span className="star">*</span></h5>)}

                            {renderQuestion('boolean', 'smoke', <h5 className="mb-1">c/ Do you smoke?<span className="star">*</span></h5>)}
                            {renderQuestion('input', 'smokesPerDay', <h5 style={{ paddingLeft: "4rem" }}>If so, how many per day?<span className="star">*</span></h5>)}

                            {renderQuestion('boolean', 'drinkAlcohol', <h5 className="mb-1">Do you drink alcohol?<span className="star">*</span></h5>)}
                            {renderQuestion('input', 'alcoholUnitPerWeek', <>  <h5 style={{ paddingLeft: "4rem" }}>If so, how many unit per week?<span className="star">*</span></h5>
                                <span style={{ fontSize: "0.85rem", paddingLeft: "4rem" }}>(N.B. 1 pint = 2 units, 1 spirit measure = 1 unit, 1 glass of wine = 1 unit)</span></>)}

                            {renderQuestion('boolean', 'deniedOrLeftJobForHealth', <h5 className="mb-1">Have you ever left or been denied, a job on health grounds?<span className="star">*</span></h5>)}

                            {renderQuestion('boolean', 'deniedDrivingLicenseForHealth', <h5 className="mb-1">Have you ever been denied a driving licence on health grounds?<span className="star">*</span></h5>)}
                            {renderQuestion('boolean', 'consideredDisable', <h5 className="mb-1">Do you consider yourself to be disabled?<span className="star">*</span><span style={{ fontSize: "0.85rem", paddingLeft: "5px" }}><i>If so, please give details below</i></span></h5>)}
                            <Col md={12} className='align-self-center'>
                                <Form.Control type="text"
                                    value={formData?.disabilityDetails}
                                    onChange={(e) => handleChangeData(e.target.value, "disabilityDetails")}
                                    className="form-control custom-input"
                                />
                            </Col>
                            {renderQuestion('boolean', 'treatedForAddiction', <h5 className="mb-1">Have you ever been treated for abuse of an addictive substance?<span className="star">*</span></h5>)}
                            {renderQuestion('boolean', 'anyMedicalConditionsAffectingEmployment', <h5 className="mb-1">Are there any medical conditions that may affect your employment with FPMcCann?<span className="star">*</span></h5>)}

                            <Col md={12} className='text-start'></Col>
                            <h5 className="mb-3">General Healthy Comments <br />
                                If you answered yes to any question e) - i) above, please provide full details below
                            </h5>
                            <Form.Group>
                                <Form.Control
                                    className={errors.generalHealthComments ? "form-control is-invalid" : "form-control"}
                                    as="textarea" rows={5}
                                    style={{
                                        height: 'auto',
                                    }}
                                    onBlur={(e) => handleCapitalWord(e, "generalHealthComments")}
                                    value={formData?.generalHealthComments}
                                    onChange={(e) => handleChangeData(e.target.value, "generalHealthComments")}
                                ></Form.Control>
                            </Form.Group>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row>
                <Col sm={12} className="d-flex justify-content-end mt-3">
                    <Button className="btn-lg btn-shadow btn-step" variamt="danger" onClick={handleBack} >Back</Button>
                    <Button className="btn-lg btn-shadow btn-step" variant="success" onClick={handleSubmit} >Next Step</Button>
                </Col>
            </Row>
        </>

    );
};

export default StepThree;